// @flow
import React, { type Node } from "react";
import queryString from "data/queryString";
import { Location } from "history";

const QueryMatchRoute = ({
    location,
    query,
    render,
}: {
    location: Location,
    query: Object,
    render: (params: Object) => React.Element,
}) => {
    // parse current URL
    const qs = queryString.parse(location.search);
    // when no required query parameters it will match only when no other URL parameters
    let isMatch = query == null && Object.keys(qs).length === 0;
    if (!isMatch) {
        isMatch =
            // no query but other URL parameters?
            query == null
                ? false // -> no match
                : Object.keys(query).every((key) => {
                      // check each required URL parameter
                      // required parameter can be anything -> make sure it's just there
                      if (query[key] === null) return qs[key] != null;
                      // required parameters needs to match a value -> make sure it's the same
                      return qs[key] != null && qs[key] === query[key];
                  });
    }
    // if matched then render component, otherwise null
    return isMatch ? render(qs) : null;
};
QueryMatchRoute.displayName = "QueryMatchRoute";

const QueryMatch = ({
    location,
    children,
}: {
    location: Location,
    children: Node,
}) =>
    React.Children.map(children, (child, index) => {
        // console.log(child);
        if (child.type === QueryMatchRoute) {
            return React.cloneElement(child, { location });
        } else {
            console.error(
                `Unsupported child of type ${child.type} for QueryMatch!`
            );
        }
    });
QueryMatch.displayName = "QueryMatch";

QueryMatch.Route = QueryMatchRoute;
export default QueryMatch;
